'use client';
import React, { useRef } from 'react';
import ArtContainer from '../ArtContainer';
import Link from 'next/link';
import { logEvent } from '@utils/googleAnalytics';
import { ImageObj } from '@custom-types/ImageObj.types';
import cn from './style.module.scss';

type Props = {
  t: Record<string, string>;
  posterSrc: string;
  videoSrc: string;
  audioSrc: string;
  exploreLink: string;
  arthouseLogoImg: ImageObj;
};
export default function ArtEpicenter(props: any) {
  const videoRef = useRef(null);
  const { t } = props;
  return (
    <section
      data-notranslate
      className={cn.artEpicenter}
      data-key={props.arthouseLogoImg?.name}
      style={{
        /* @ts-ignore */
        '--arthouse-logo': `url(${props.arthouseLogoImg?.url})`,
      }}
    >
      <div className={cn.epicInner}>
        <div className={cn.epicHeader}>
          <div className={cn.headerStory}>
            <ArtContainer>
              <h4>
                {!props.launch ? t['welcomeText'] : t['launchWelcomeText']}
              </h4>
            </ArtContainer>
          </div>
        </div>
        <div className={cn.epicBlock}>
          <div className={cn.epicBody}>
            <div className={cn.epicContent}>
              <div className={cn.epicContent__heading}>
                <h2>{t['epicLaunchHeading']}</h2>
              </div>
              <div className={cn.epicContent__paragraph}>
                <p>{t['epicLaunchContent']}</p>
              </div>
              <div className={cn.buttonBlock}>
                <Link
                  href={props.exploreLink}
                  target="_blank" rel="noopener noreferrer"
                  data-event-name="launch-explore-district-click"
                  onClick={() => {
                    logEvent({
                      event: 'launch-explore-district-click',
                      additionalInfo: {
                        link_id: 'launch-explore-district-click',
                      },
                    });
                  }}
                  className={cn.exploreButton}
                >
                  <span>{t['exploreButton']}</span>
                  <span className={cn.exploreIcon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 13.686 13.686"
                    >
                      <path
                        d="M53.606,35.686A.605.605,0,0,1,53,35.08V22.606A.606.606,0,0,1,53.606,22h4.756a.606.606,0,0,1,0,1.212H54.212V34.474H65.475V30.323a.606.606,0,1,1,1.212,0V35.08a.605.605,0,0,1-.606.606Zm6.236-6.841a.6.6,0,0,1,0-.857l4.777-4.777H61.59a.606.606,0,0,1,0-1.212h4.491a.606.606,0,0,1,.606.606V27.1a.606.606,0,1,1-1.212,0V24.068L60.7,28.845a.606.606,0,0,1-.857,0Z"
                        transform="translate(-53 -22)"
                      />
                    </svg>
                  </span>
                </Link>
              </div>
            </div>
          </div>
          <div className={cn.epicDescription}>
            <div className={cn.epicVideo}>
              <video poster={props.posterSrc} muted autoPlay loop playsInline>
                <source src={props.videoSrc} />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
